import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import LoadingOverlay from "react-loading-overlay-ts";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthLayout from "./layouts/auth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LoadingProvider, useLoading } from "./context/LoadingContext";
import { AuthProvider } from "./context/LoginContext";
import { RolePermissionProvider } from "./context/RolePermissionContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoginPage from "./pages/LoginPage";
import { renderRoutes } from "./DynamicRoutes";
import { routesConfig } from "./routesConfig";
import NotFoundPage from "./pages/NotFoundPage";
import { removeCookieData } from "./helper/api";
import TalentTigersLoginPage from "./pages/TalentTigersLoginPage";
// Single-tab guard is applied only within IPMS layout

const App: React.FC = () => {
  const { isLoading, loadingText } = useLoading();
  const location = useLocation();
  React.useEffect(() => {
    if (location.pathname !== "/timesheetReport") {
      removeCookieData("reportstateDate");
    }
    if (
      location.pathname !== "/mytimesheetreport" &&
      location.pathname !== "/reviewApproveTimesheet"
    ) {
      removeCookieData("timesheetsReport");
    }
  }, [location.pathname]);
  // const { isAuthenticated } = useAuth();
  // const navigate = useNavigate();
  // React.useEffect(() => {
  //   const userData = getCookieData("userData");

  //   if (userData) {
  //     const redirectPath = getCookieData("redirectPath");
  //     if (redirectPath) {
  //       navigate(redirectPath);
  //       removeCookieData("redirectPath");
  //     }
  //   }
  //   // if (!isAuthenticated || !isAuthenticated && !userData) {
  //   //   logout();
  //   // }
  // }, [isAuthenticated, navigate, getCookieData]);

  return (
    <LoadingOverlay active={isLoading} spinner text={loadingText}>
      <ToastContainer />
      <Outlet />
      <Routes>
        <Route path='login' element={<AuthLayout />}>
          <Route path='' element={<LoginPage />} /> {/* Login Page Route */}
        </Route>
        <Route path='login-tt' element={<TalentTigersLoginPage />} />
        {renderRoutes(routesConfig)}
        <Route path='' element={<Navigate to='/login' />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </LoadingOverlay>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <LoadingProvider>
      <GoogleOAuthProvider clientId='1057107116184-31i5d8i1kn9os3futjktmclp3c6cfj7c.apps.googleusercontent.com'>
        <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <RolePermissionProvider>
                <App />
              </RolePermissionProvider>
            </AuthProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </LoadingProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
